import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import { Link as Link$1 } from 'react-router-dom';
import { block } from '../../utils/block.js';
import './Link.scss.js';
import { jsx } from 'react/jsx-runtime';

const _excluded = ["type", "link", "children", "onClick", "color", "size", "disabled", "className"];
const b = block('link');
const Link = _ref => {
  let {
      type,
      link,
      children,
      onClick,
      color,
      size,
      disabled = false,
      className = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const href = disabled ? '/' : link;
  if (type === 'external') {
    return /*#__PURE__*/jsx("a", _objectSpread2(_objectSpread2({
      className: b({
        size,
        color,
        disabled
      }).mix(className),
      href: href,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: onClick,
      "aria-disabled": disabled
    }, rest), {}, {
      children: children
    }));
  }
  return /*#__PURE__*/jsx(Link$1, _objectSpread2(_objectSpread2({
    className: b({
      size,
      color,
      disabled
    }).mix(className),
    to: href,
    "aria-disabled": disabled
  }, rest), {}, {
    children: children
  }));
};

export { Link };
